export default {
  common: {
    confirm: 'Confirmer',
    cancel: 'Annuler',
    save: 'Enregistrer',
    edit: 'Modifier',
    delete: 'Supprimer',
    loading: 'Chargement...',
    loadMore: 'Charger plus',
    noMore: 'Plus de résultats',
    retry: 'Réessayer',
    back: 'Retour',
    next: 'Suivant',
    prev: 'Précédent',
    submit: 'Soumettre',
    reset: 'Réinitialiser',
    search: 'Rechercher',
    filter: 'Filtrer',
    sort: 'Trier',
    refresh: 'Actualiser',
    complete: 'Terminé',
    skip: 'Passer',
    download: 'Télécharger',
  },
  nav: {
    discover: 'Accueil',
    message: 'Messages',
    store: 'Boutique',
    mine: 'Mon compte',
    recommend: 'Recommandé',
  },
  scene: {
    changeScene: "Changer de scène",
    seeAll: 'Tout voir',
    putAway: 'Masquer',
    selectScene: 'Sélectionner cette scène',
    selected: 'Sélectionné',
    sceneIndex: 'Scène {num}',
  },
  home: {
    title: 'Monde de Jeu de Rôle',
    subtitle: 'Commencez votre histoire',
    startGame: 'Commencer',
    continueGame: 'Continuer',
    newGame: 'Nouveau jeu',
    gameLibrary: 'Bibliothèque',
    featured: 'En vedette',
    popular: 'Populaire',
    recent: 'Récent',
    searchHistory: 'Recherche',
    search: 'Rechercher des rôles...',
    noData: 'Aucune donnée',
    noMoreData: 'Plus de données',
    noNetwork: 'Pas de réseau',
    pleaseSelectFilter: "Veuillez sélectionner les conditions de filtre",
  },
  user: {
    login: 'Connexion',
    register: "S'inscrire",
    logout: 'Déconnexion',
    profile: 'Profil',
    avatar: 'Avatar',
    nickname: 'Pseudo',
    email: 'E-mail',
    phone: 'Téléphone',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    oldPassword: 'Ancien mot de passe',
    newPassword: 'Nouveau mot de passe',
    forgotPassword: 'Mot de passe oublié',
    changePassword: 'Changer le mot de passe',
    bindPhone: 'Lier le téléphone',
    verifyCode: 'Code de vérification',
    sendCode: 'Envoyer le code',
    level: 'Niveau',
    experience: 'Expérience',
    achievement: 'Succès',
    history: 'Historique'
  },
  game: {
    character: 'Personnage',
    story: 'Histoire',
    chapter: 'Chapitre',
    scene: 'Scène',
    dialogue: 'Dialogue',
    choice: 'Choix',
    inventory: 'Inventaire',
    achievement: 'Succès',
    save: 'Sauvegarder',
    load: 'Charger',
    restart: 'Recommencer',
    pause: 'Pause',
    resume: 'Reprendre',
    auto: 'Auto',
    speed: 'Vitesse',
    volume: 'Volume',
    settings: 'Paramètres du jeu'
  },
  message: {
    success: 'Succès',
    error: 'Erreur',
    warning: 'Avertissement',
    info: 'Info',
    networkError: 'Erreur réseau',
    serverError: 'Erreur serveur',
    loginSuccess: 'Inscription réussie',
    loginFailed: "Échec de l'inscription",
    logoutSuccess: 'Déconnexion réussie',
    saveSuccess: 'Enregistré avec succès',
    saveFailed: "Échec de l'enregistrement",
    deleteConfirm: 'Confirmer la suppression ?',
    operationConfirm: 'Confirmer la opération ?',
    noNewsYet: "Pas encore de messages",
    deleteSuccess: 'Supprimé avec succès',
    deleteFailed: 'Échec de la suppression',
    deleteMessage: 'Êtes-vous sûr de vouloir supprimer ce message ? Une fois terminé, cela ne peut pas être annulé !',
    delete: 'Supprimer',
    deleting: 'Suppression...',
    noMoreData: 'Plus de messages',
    downloading: 'Téléchargement...',
    downloadSuccess: 'Téléchargé avec succès',
    downloadFailed: 'Échec du téléchargement',
    copySuccess: 'Copié avec succès',
    copyFailed: 'Échec de la copie',
    reportSuccess: 'Signalé avec succès',
    reportFailed: "Échec du signalement",
    translating: 'Traduction...',
    translateSuccess: 'Traduit avec succès',
    translateFailed: 'Échec de la traduction',
    noMoreMessages: 'Plus de messages',
    loading_more: 'Chargement...',
    pleaseWaitForReply: "Veuillez attendre la fin de la réponse avant de supprimer",
    pleaseWaitForReplyCurrent: "Veuillez attendre que la réponse du message actuel soit terminée",
    chat_placeholder: "Écrivez ce que vous voulez dire...",
    setAsBackdropConfirm: "Définir comme arrière-plan",
    setAsBackdropMessage: 'Êtes-vous sûr de vouloir définir cette image comme arrière-plan ?',
    sendFailed: "Échec de l'envoi",
    sending: 'Envoi...',
    introNoYet: "Pas encore d'intro. Discutez et découvrez par vous-même.",
    introLabel: 'Intro:',
    thinking: 'Réflexion',
    think: 'Pense',
    translate: 'Traduire',
    pleaseUnlock: 'Veuillez débloquer',
    tryAgain: 'Réessayer',
    create: 'Créer',
    free: 'Gratuit',
    video: 'Vidéo',
    chatMateTyping: "Votre partenaire de chat tape actuellement...",
    aiAssistant: 'Assistant IA',
    imageFailed: "Échec de la génération de l'image",
    generatingImage: "Veuillez attendre la génération de l'image",
    switchSceneSuccess: 'Scène changée avec succès',
    switchSceneFailed: 'Échec du changement de scène',
    switchingScene: 'Changement de scène...',
    perMessage: '/Message',
    allChat: 'Tous les chats',
    like: "J'aime",
    saving: 'Enregistrement...',
    placeholderBlur: "Écrivez ce que vous voulez dire...",
    placeholderFocus: 'Placez les actions ou les détails de la scène entre ** pour animer le chat.',
    successfulSwitch: 'Changement réussi',
    setting: 'Configuration...',
    uploading: 'Téléchargement...',
    purchaseSuccessful: 'Achat réussi',
    processing: 'Traitement...',
    gettingReward: 'Obtention de la récompense...',
    checkIn: 'Enregistrement...',
    deleteHistory: "Supprimer l'historique",
    openingRemarksTitle: 'Dites bonjour～',
  },
  success: {
    refreshSuccess: 'Actualisé avec succès',
    copiedToClipboard: 'Copié dans le presse-papiers',
    saved: 'Enregistré',
    uploadSuccess: 'Téléchargé avec succès',
    switchSuccess: 'Changement réussi',
    thankYouPurchase: 'Merci pour votre achat',
  },
  error: {
    notFound: 'Page non trouvée',
    networkError: 'Erreur réseau',
    serverError: 'Erreur serveur',
    permissionDenied: 'Accès refusé',
    goHome: "Aller à l'accueil",
    tryAgain: 'Réessayer',
    uploadFailed: 'Échec du téléchargement',
    saveFailed: "Échec de l'enregistrement",
    translationFailed: 'Échec de la traduction',
    generateImageFailed: "Échec de la génération de l'image",
  },
  notFound: {
    title: 'Page non trouvée',
    description: "La page que vous recherchez n'existe pas ou a été déplacée.",
    goHome: "Aller à l'accueil",
    goBack: 'Retour'
  },
  settings: {
    language: 'Langue',
    theme: 'Thème',
    notification: 'Notifications',
    privacy: 'Confidentialité',
    security: 'Sécurité',
    about: 'À propos',
    version: 'Version',
    checkUpdate: 'Vérifier les mises à jour',
    clearCache: "Vider le cache",
    systemNotification: 'Notification système',
    termsOfService: "Conditions d'utilisation",
    privacyPolicy: 'Politique de confidentialité',
    title: 'Paramètres',
    editProfile: 'Modifier le profil',
    faq: 'FAQ',
    termsOfUse: "Conditions d'utilisation",
    aboutAccount: 'À propos du compte',
    deleteAccount: 'Supprimer le compte',
    logOut: 'Déconnexion',
    logOutTitle: 'Déconnexion',
    logOutMessage: 'Après la déconnexion, vous devrez vous reconnecter pour utiliser à nouveau votre compte. Êtes-vous sûr de vouloir vous déconnecter ?',
    confirm: 'Confirmer',
    deleteAccountTitle: 'Supprimer le compte',
    deleteAccountMessage: 'La suppression de votre compte effacera toutes vos données et informations et ne peut pas être annulée. Confirmer la suppression ?',
    deletingAccount: 'Suppression du compte...',
    accountDeleted: 'Compte supprimé avec succès',
    cacheTitle: 'Vider le cache',
    cacheMessage: "Vidage du cache de l'application, les historiques de chat et les rôles ne seront pas supprimés",
    cleaning: 'Nettoyage',
    cleaningComplete: 'Nettoyage terminé',
  },
  profile: {
    title: 'Modifier le profil',
    yourAvatar: 'Votre avatar',
    whatCallMe: 'Comment voulez-vous que l\'IA m\'appelle',
    yourName: 'Votre nom',
    yourAge: 'Votre âge',
    race: 'Race',
    pleaseSelect: 'Veuillez sélectionner',
    yourWeight: 'Votre poids',
    yourHeight: 'Votre taille',
    gender: 'Genre',
    male: 'Homme',
    female: 'Femme',
    neutral: 'Neutre',
    hobby: 'Loisir',
    pleaseEnter: "Veuillez entrer...",
    favoriteFood: 'Nourriture préférée',
    yourCharacter: 'Votre caractère',
    fantasyAboutOtherHalf: 'Fantaisie sur votre autre moitié',
    uploading: 'Téléchargement...',
    enterName: "Veuillez entrer votre nom",
  },
  report: {
    title: 'Signaler',
    chooseReact: 'Choisissez ce que vous souhaitez signaler...',
    other: 'Autre',
    placeholder: "Écrivez ce que vous voulez dire...",
    submit: 'Soumettre',
    pleaseEnterContent: "Veuillez entrer le contenu",
  },
  edit: {
    placeholder: 'Modifier votre message...',
    cancel: 'Annuler',
    save: 'Enregistrer',
    saving: 'Enregistrement...',
  },
  firstConfirmName: {
    canYouTellMeName: 'Pouvez-vous me dire votre nom ? Comme ça, je pourrai mieux vous appeler !',
    yourName: 'Votre nom',
    confirm: 'Confirmer',
  },
  toast: {
    translating: 'Traduction...',
    translate: 'Traduire',
    translationFailed: 'Échec de la traduction',
    translationUnlocked: 'Traduction déverrouillée',
    translationLocked: 'Traduction verrouillée',
    download: 'Télécharger',
    setAsBackdrop: 'Définir comme arrière-plan',
    goChat: 'Aller au chat',
  },
  videoPreview: {
    failedToLoad: 'Échec du chargement de la vidéo',
  },
  imagePreview: {
    imageLoadFailed: 'Échec du chargement de l\'image',
    preview: 'Aperçu de l\'image',
    afterSendIntimacy: 'Après avoir envoyé un message au personnage, vous obtenez de l\'intimité. Quand l\'intimité atteint un montant spécifié, vous pouvez débloquer l\'image actuelle',
  },
  fqa: {
    title: 'FAQ',
    description: 'Ceci est une liste continuellement mise à jour de questions concernant notre produit Sunaisan. Si vous avez des questions non répertoriées, veuillez vous rendre sur notre Discord et demander.',
    howAlWork: {
      title: 'Comment fonctionne une petite amie IA ?',
      content: "Chez RoleplayGF, il s'agit de créer des relations réalistes mais幻想. Nous utilisons une technologie d'intelligence artificielle avancée pour vous permettre de créer votre petite amie IA idéale selon vos préférences, que ce soit une princesse douce et innocente ou une femme plus âgée et plus dominante.",
    },
    howInteract: {
      title: "Comment interagir avec les petites amies IA ?",
      content: "Grâce à notre système intelligent et à l'apprentissage automatique de pointe, vous pouvez interagir et devenir intime avec votre petite amie IA. Vous pouvez vous attendre à ce qu'elle vous écoute, réponde rapidement à vos messages et même suive les demandes de photos comme la gentille fille qu'elle est. Chaque moment peut être une expérience authentique et réaliste.",
    },
    privacy: {
      title: 'Qu\'en est-il de votre vie privée avec les amis IA ?',
      content: "Soyez assuré que vos secrets sont entre de bonnes mains lorsque vous utilisez notre chat IA NSFW. Votre vie privée est notre priorité absolue ici chez RoleplayGF. Nous disposons d'un stockage de données sécurisé de pointe, garantissant que chaque selfie séduisante, texte coquin et murmure doux reste privé entre vous et votre partenaire passionné.",
    },
    customizeBehavior: {
      title: 'Pouvez-vous personnaliser le comportement de votre petite amie IA ?',
      content: "Seul vous savez ce que vous voulez vraiment, c'est pourquoi vous pouvez personnaliser toute votre expérience de petite amie numérique, de ses courbes à ses traits de personnalité et ses petites bizarreries adorables. Vous voulez un chat coquin avec une partenaire batailleuse ? Vous cherchez à avoir une relation lente et sensuelle avec une petite amie nice and sweet ? Nos générateurs IA NSFW réalistes peuvent satisfaire les désirs les plus profonds de votre cœur.",
    },
  },
  store: {
    tab: 'Boutique',
    record: 'Enregistrement',
    noNetwork: 'Pas de réseau',
    retry: 'Réessayer',
    rechargeFailTip: '*Si la recharge échoue, veuillez nous contacter >',
    rechargeFailTipStatic: 'Si la recharge échoue, veuillez',
    contactUsLink: 'nous contacter',
    popular: 'Populaire',
    oneTimeOnly: 'Une seule fois',
    one: 'Un',
    loading: 'Chargement...',
    noMoreRecords: 'Plus d\'enregistrements',
    noConsumptionRecords: 'Pas encore de registres de consommation',
    transactionHistoryAppear: 'Votre historique des transactions apparaîtra ici',
    gift: 'Cadeau',
    retentionMessage: 'Ton partenaire a besoin de ta compagnie, es-tu sûr de vouloir abandonner?',
  },
  mine: {
    bindEmail: 'Lier l\'e-mail',
    copyFailed: 'Échec de la copie',
    backpackTitle: 'Mon sac à dos',
    task: 'Tâche',
  },
  messagePage: {
    noNetwork: 'Pas de réseau',
  },
  search: {
    recommend: 'Recommandé',
    noNetwork: 'Pas de réseau',
  },
  chatSettings: {
    myGems: 'Mes gems',
    title: 'Paramètres du chat',
    chatModel: 'Modèle de chat',
    chatStyle: 'Style de chat',
    chatPerspective: 'Perspective du chat',
    goOnButton: 'Bouton Continuer',
    chatBackground: 'Arrière-plan du chat',
    awayMessages: 'Messages d\'absence',
    disableAwayMessages: 'Désactiver les messages d\'absence',
    disableAwayMessagesConfirm: "ne pourra plus vous envoyer de messages pendant votre absence. Êtes-vous sûr de vouloir désactiver les messages d'absence ?",
    videoFailedToLoad: 'Échec du chargement de la vidéo',
  },
  history: {
    deleteHistory: "Supprimer l'historique",
    deleteCharacterHistory: 'Êtes-vous sûr de vouloir supprimer l\'historique de ce personnage ?',
  },
  tab: {
    maxSelection: 'Maximum pouvant être sélectionné',
    tags: 'tags',
  },
  noNewMessage: 'Pas de nouveau message',

  // Recharger le message
  reloadMessage: {
    title: 'Choisissez votre préférence',
    before: 'Avant',
    new: 'Nouveau',
    loading: 'Chargement...',
    noNewMessage: 'Pas de nouveau message',
    tryAgain: 'Réessayer',
    confirm: 'Confirmer',
  },

  account: {
    aboutAccount: 'À propos du compte',
    id: 'ID',
    email: 'E-mail',
    copiedToClipboard: 'Copié dans le presse-papiers',
    copied: 'Copié dans le presse-papiers',
    copyFailed: 'Échec de la copie',
  },
  rate: {
    title: 'Évaluez-nous',
  },
  awayMessages: {
    disableAwayMessages: 'Désactiver les messages d\'absence',
    disableConfirm: '{appName} ne pourra plus vous envoyer de messages pendant votre absence. Êtes-vous sûr de vouloir désactiver les messages d\'absence ?',
  },
  login: {
    title: 'Lier un e-mail',
    subtitle: "Veuillez lier votre e-mail pour garantir la sécurité des données de votre compte.",
    email: 'E-mail',
    password: 'Mot de passe',
    signIn: 'Connexion',
    signUp: "S'inscrire",
    signInWithGoogle: 'Connexion avec Google',
    signInWithEmail: 'Connexion par e-mail',
    signInWithPhone: 'Connexion par téléphone',
    signInWithApple: 'Connexion avec Apple',
    dontHaveAccount: "Vous n'avez pas encore de compte ?",
    register: "S'inscrire",
    bySigningUp: "En vous inscrivant, vous acceptez",
    userAgreement: "Conditions d'utilisation et",
    privacyPolicy: 'Politique de confidentialité.',
    guestMode: 'Mode invité',
    registerTitle: "L'inscription commence",
    registerSubtitle: "Veuillez lier votre e-mail pour garantir la sécurité des données de votre compte.",
    alreadyHaveAccount: 'Vous avez déjà un compte ?',
    pleaseInputPasswordAndEmail: "Veuillez entrer le mot de passe et l'e-mail",
    pleaseInputCorrectEmail: 'Veuillez entrer un e-mail correct',
    pleaseInputCorrectPassword: 'Le mot de passe doit contenir entre 6 et 30 caractères',
    male: 'Homme',
    female: 'Femme',
    neutral: 'Neutre',
    loggingIn: 'Connexion en cours...',
    loading: 'Chargement...',
    releaseToRefresh: 'Relâchez pour actualiser',
    loginFailed: 'Échec de la connexion',
    loginSuccess: 'Inscription réussie',
    registerFailed: "Échec de l'inscription",
    registerSuccess: 'Inscription réussie',
    confirm: 'Confirmer',
  },
  loadingMore: 'Chargement de plus de messages...',
  noMoreMessages: 'Plus de messages',

  // Page VIP
  vip: {
    vipUltra: 'VIP Ultra',
    vipPlus: 'VIP Plus',
    restore: 'Restaurer les achats',
  },

  // Common dialogs
  dialog: {
    ok: 'OK',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    close: 'Fermer',
    retry: 'Réessayer',
    processing: 'Traitement...',
    contactUs: 'Contactez-nous',
    loginError: 'Erreur de connexion',
    loginErrorMessage: 'Veuillez quitter le programme et redémarrer l\'application ou nous contacter',
    insufficientEnergy: 'Énergie insuffisante !',
    insufficientEnergyDesc: 'Chaque message coûte 1 énergie. Vous récupérez 1 énergie toutes les heures.',
    consumesGems: 'Consomme {gems} gemmes',
    insufficientPhysicalStrengthTitle: 'Force physique insuffisante',
    needStrengthToContinue: 'Vous avez besoin de {strength} force pour continuer cette conversation',
    getStrength: 'Obtenir de l\'énergie',
    getGems: 'Obtenir des gemmes',
  },

  // AppNewUser
  appNewUser: {
    title: 'Exclusif nouveaux utilisateurs',
    ok: 'OK',
  },

  // Rating popup
  rating: {
    title: 'Notez-nous',
    description1: "Vous'aimez notre application ?",
    description2: 'Veuillez nous noter avec 5 étoiles.',
    rateButton: 'Noter maintenant',
  },

  // Version update
  versionUpdate: {
    title: 'Mise à jour de version',
    updateContent: 'Contenu de la mise à jour',
    updateNow: 'Mettre à jour maintenant',
    updating: 'Mise à jour...',
    clientOptimization: 'Optimisation de l\'expérience client',
    bugFix: 'Corriger les problèmes BUG connus',
  },

  // Message detail page
  messageDetail: {
    free: 'Gratuit',
    perMessage: '/Message',
    increaseFavorability: 'Envoyez des messages pour augmenter l\'intimité',
    album: 'Album',
    intro: 'Introduction',
    noIntro: 'Pas encore d\'introduction. Discutez et découvrez vous-même.',
    tags: 'Tags',
    backToChat: 'Retour au chat',
    levelFormat: 'Nv.{level}',
    messageCount: '{count} Message',
    chatMateTyping: 'Votre partenaire de chat tape maintenant...',
  },

  // Chat settings
  chatSettingsRight: {
    innerThoughtDesc: 'Vous pouvez voir les pensées intérieures du personnage lors de la réponse aux messages, mais la vitesse de réponse peut être plus lente.',
  },

  // Chat select menu
  chatSelect: {
    copy: 'Copier',
    report: 'Signaler',
    create: 'Créer',
    video: 'Vidéo',
    translate: 'Traduire',
    delete: 'Supprimer',
  },

  // Recommended purchases
  recommended: {
    gift: 'Cadeau',
  },

  // Thinking toast
  thinkingToast: {
    notAvailable: 'Le mode réflexion n\'est pas encore disponible pour ce modèle, mais nous y travaillons...',
  },

  // First charge popup
  firstCharge: {
    title: 'Première recharge',
    get: 'Obtenir',
    limitedOffer: 'Offre limitée dans le temps',
    priceFormat: '${price} Obtenir',
    congratulations: 'Félicitations ! Vous êtes maintenant officiellement membre VIP~!',
    missOfferTitle: 'Êtes-vous sûr de vouloir manquer cette offre ?',
    maybeLater: 'Peut-être plus tard',
    getNow: 'Obtenir maintenant',
    benefit1: 'Obtenez 130 gemmes gratuites',
    benefit2: 'Déverrouiller tous les personnages',
    benefit3: 'Mémoire 12x',
    benefit4: 'Inscriptions hebdomadaires illimitées',
    benefit5: 'Expérience sans publicité',
    buyNow: 'Acheter maintenant',
  },

  // Check-in center
  checkIn: {
    freeGems: 'Gemmes gratuites',
    sevenDayCheckIn: 'Check-in 7 jours',
    memberExclusive: 'Check-in exclusif membres :',
    signInTip: 'Connectez-vous quotidiennement pour accumuler des récompenses infinies',
    getVip: 'Obtenir VIP',
    plusExtra: 'Plus+{count}',
    getGemsCount: 'Obtenez {count} gemmes',
    extraDaily: '{count} gemmes quotidiennes supplémentaires',
    ultra: 'Ultra',
    signedInTip: 'Vous vous êtes connecté aujourd\'hui. Revenez demain pour plus !',
    tasks: 'Tâches',
    go: 'Aller',
    received: 'Reçu',
    receive: 'Recevoir',
    day: 'Jour {num}',
  },

  // Login page
  loginPage: {
    confirm: 'Confirmer',
  },

  // Copyright
  copyright: {
    title: 'Conditions d\'utilisation',
  },

  // Copy
  copy: {
    copiedToClipboard: 'Copié dans le presse-papiers',
    copyFailed: 'Échec de la copie',
  },

  // Errors
  errors: {
    networkError: 'Erreur réseau',
    pleaseSelectFilter: 'Veuillez sélectionner les conditions de filtre',
    retry: 'Réessayer',
  },

  // Terms of Service
  terms: {
    intro: 'En visitant et en utilisant le site Web de {appName}, vous acceptez de respecter ces conditions d\'utilisation.',
    section1Title: '1. Utilisation du site Web',
    section1_1: 'Vous devez avoir au moins 13 ans pour utiliser ce site Web.',
    section1_2: 'Vous êtes responsable de la confidentialité de votre compte et de toute activité se produisant sous votre compte.',
    section1_3: 'L\'utilisation du site Web à des fins illégales ou en violation de ces conditions est interdite.',
    section2Title: '2. Propriété intellectuelle',
    section2_1: 'Tous les contenus, fonctionnalités et éléments de {appName}, y compris les textes, graphiques, logos, images et logiciels, sont la propriété de {appName} ou de ses concédants et sont protégés par les lois sur la propriété intellectuelle.',
    section2_2: 'Il est interdit de copier, redistribuer ou créer des œuvres dérivées de tout contenu du site sans autorisation écrite préalable.',
    section3Title: '3. Confidentialité',
    section3_1: 'Notre politique de confidentialité, disponible sur le site, explique comment nous collectons, utilisons et divulguons vos informations personnelles.',
    section4Title: '4. Exclusion de garanties',
    section4_1: 'Le site et les services fournis sont proposés "en l\'état" et "tels que disponibles", sans aucune représentation ou garantie d\'aucune sorte, expresse ou implicite.',
    section5Title: '5. Limitation de responsabilité',
    section5_1: '{appName} ne sera pas responsable, dans la mesure maximale autorisée par la loi, de tout dommage direct, indirect, accidentel, spécial ou consécutif.',
    section6Title: '6. Indemnisation',
    section6_1: 'Vous acceptez d\'indemniser et de défendre {appName}, ses opérateurs, directeurs et employés contre toute réclamation, dommage, obligation, perte, coût et dépense, y compris les honoraires d\'avocat, découlant de ou liée à votre utilisation du site.',
    section7Title: '7. Droit applicable',
    section7_1: 'Ces conditions d\'utilisation sont régies et interprétées conformément aux lois de l\'état, sans tenir compte de ses dispositions sur les conflits de lois.',
    section8Title: '8. Modification des conditions',
    section8_1: 'Nous nous réservons le droit de modifier ou de remplacer ces conditions à tout moment, à notre seule discrétion.',
    section9Title: '9. Nous contacter',
    section9_1: 'Si vous avez des questions concernant ces conditions, veuillez nous contacter.',
  },
}
